import { LoadablePaint } from '@confluence/loadable';

export const LazyJiraMacroRepairPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-JiraMacroRepairContainer" */ '../src/JiraMacroRepair/JiraMacroRepairPage.tsx'
			)
		).JiraMacroRepairPage,
});
